import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DxHtmlEditorComponent } from 'devextreme-angular';

export interface TextEditorData {

}

export interface TextEditorResult {
  value: string;
  bgColor: string;
  color: string;
}

@Component({
  standalone: false,
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css']
})
export class TextEditorComponent implements OnInit {
  @ViewChild('editor') editor?: DxHtmlEditorComponent;

  backgroundColor: string = 'none';
  color: string = 'black';

  constructor(
    public dialogRef: MatDialogRef<TextEditorComponent, TextEditorResult>,
    @Inject(MAT_DIALOG_DATA) public data: TextEditorData,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
  }

  cancel(): void {
    this.dialogRef.close();
  }

  bgColorChanged(event: { value: string, previousValue: string }): void {
    if (!this.editor) {
      return;
    }

    const { value } = event;
    this.backgroundColor = value;

    const editorBody: HTMLElement = ((this.editor.instance.element() as any).children.item(1));
    editorBody.style.backgroundColor = this.backgroundColor;
  }

  colorChanged(event: { value: string, previousValue: string }): void {
    if (!this.editor) {
      return;
    }

    const { value } = event;
    this.color = value;

    const editorBody: HTMLElement = ((this.editor.instance.element() as any).children.item(1));
    editorBody.style.color = this.color;
  }

  add(): void {
    const value: string = this.editor.value;
    if (value === null || value === undefined || value.trim() === '') {
      this.showErrorMessage('Enter text to add!');
      return;
    }

    this.dialogRef.close({
      value,
      bgColor: this.backgroundColor,
      color: this.color
    });
  }

  private showErrorMessage(message: string) {
    this.snackBar.open(message, 'Error', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }
}
